import { message } from "antd";
import request from "axios";
import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router";
import { login } from "../../store/actions/login";
import { LOGIN } from "../../store/constants";
import { getMcpLoginResume, isMcpAuthorizationUrl } from "../../utils/mcpOAuth";
import { getLocationOrigin } from "../../utils/util";
import {
  setCompany,
  setSuperGroup,
  setToken,
  getToken,
  getRedirectUrl,
  getDeploy,
} from "../../utils/cookie";

export default function Login() {
  const history = useHistory();
  const dispatch = useDispatch();
  useEffect(() => {
    const query = new URLSearchParams(window.location.search);
    const returnUrl = query.get('redirect') || getRedirectUrl();
    // 恢复记录本身不能抢占之后发起的普通业务登录。
    const mcpResume = isMcpAuthorizationUrl(returnUrl) ? getMcpLoginResume() : null;
    if (mcpResume && mcpResume === returnUrl) {
      const target = new URL(getLocationOrigin() + '/loading');
      target.searchParams.set('redirect', mcpResume);
      if (query.get('ticket')) target.searchParams.set('ticket', query.get('ticket'));
      if (query.get('code')) target.searchParams.set('code', query.get('code'));
      window.location.replace(target.href);
      return;
    }
    if (getToken()) {
      // if (getRedirectUrl()) {
      //   window.location.href = getRedirectUrl();
      // } else {
      history.push("/home");
      // }
      localStorage.setItem("firstLogin", true);
      return;
    }
    const redirectUrl = getRedirectUrl();
    let useSaas = false;
    if (redirectUrl?.includes("/saas")) {
      useSaas = true;
    }
    console.log("使用saas登录", useSaas);
    dispatch(login(getDeploy() === 'BOX' ? undefined : useSaas)).then((res) => {
      console.log(res);
      if (res) {
        console.log("home");
        message.success("登录成功");
        const to = localStorage.getItem('to');
        localStorage.removeItem('to')
        if(to){
          localStorage.setItem("firstLogin", true);
          history.push(to);
          return
        }
        history.push('/home')
        // if (getRedirectUrl()) {
        //   window.location.href = getRedirectUrl();
        // } else {
        // }
        localStorage.setItem("firstLogin", true);
      }
    });
  }, []);
  return <div></div>;
}
